"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Step = void 0;
const task_canceled_error_1 = require("./task-canceled-error");
class Step {
    constructor(name, runLogic, cancelLogic) {
        this.taskSelfResolvers = new Map();
        this.taskStepInfos = new Map();
        this.name = name;
        this.runLogic = runLogic;
        this.cancelLogic = cancelLogic;
    }
    run(task, inputValue) {
        return __awaiter(this, void 0, void 0, function* () {
            this.addStepInfo(task, { name: this.name });
            return new Promise((resolve) => {
                const startTime = new Date();
                const resolveItself = (outputValue, error) => {
                    const endTime = new Date();
                    const duration = endTime.getTime() - startTime.getTime();
                    this.addStepInfo(task, { startTime, endTime, duration });
                    this.addStepInfo(task, error ? { success: false, error } : { success: true });
                    resolve({ resultValue: outputValue, info: this.getStepInfo(task) });
                };
                this.taskSelfResolvers.set(task, resolveItself);
                this.runLogic(task, inputValue)
                    .then((result) => {
                    return resolveItself(result);
                })
                    .finally(() => {
                    this.taskSelfResolvers.delete(task);
                    this.taskStepInfos.delete(task);
                })
                    .catch((error) => {
                    return resolveItself(undefined, error);
                });
            });
        });
    }
    cancel(task, reason) {
        return __awaiter(this, void 0, void 0, function* () {
            this.addStepInfo(task, { wasCanceled: true, cancelingReason: reason });
            const resolveItself = this.taskSelfResolvers.get(task);
            resolveItself === null || resolveItself === void 0 ? void 0 : resolveItself(undefined, new task_canceled_error_1.TaskCanceledError(reason));
            this.taskSelfResolvers.delete(task);
            this.taskStepInfos.delete(task);
            yield this.cancelLogic(task, reason);
        });
    }
    addStepInfo(task, stepInfo) {
        const currentStepInfo = this.taskStepInfos.get(task) || {};
        const newStepInfo = Object.assign(Object.assign({}, currentStepInfo), stepInfo);
        this.taskStepInfos.set(task, newStepInfo);
    }
    getStepInfo(task) {
        return this.taskStepInfos.get(task);
    }
}
exports.Step = Step;
//# sourceMappingURL=step.js.map